import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';

export type ConfirmPaymentDetailsDataType = {
  notes?: string;
};

export const confirmPaymentDetailsApi = (
  wireId: string,
  data?: ConfirmPaymentDetailsDataType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/recipient/wires/${wireId}/payment-details/confirm/`;

  return authApiService.POST(uri, data);
};
